import { Box, Button } from '@mui/material';
import { Page } from './types';
import { router } from './router';
import { usePath } from './use-path';

interface NavigationProps {
  pages: Page[];
}

export const Navigation = ({ pages }: NavigationProps) => {
  const { path } = usePath();

  return (
    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, py: 1 }}>
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.5,
          p: 0.5,
          borderRadius: 999,
          border: '1px solid var(--ds-button-secondary-border)',
          background: 'var(--ds-button-secondary-gradient)'
        }}
      >
        {pages.map((page) => {
          const isActive = path === page.path;

          return (
            <Button
              key={page.title}
              onClick={() => router.navigate(page.path)}
              sx={{
                px: 1.6,
                py: 0.6,
                minWidth: 'fit-content',
                borderRadius: 999,
                textTransform: 'none',
                lineHeight: 1.2,
                letterSpacing: '0.01em',
                border: '1px solid',
                borderColor: isActive
                  ? 'var(--ds-button-primary-border)'
                  : 'transparent',
                fontWeight: isActive ? 700 : 600,
                color: isActive
                  ? 'var(--ds-button-primary-text)'
                  : 'var(--ds-button-secondary-text)',
                background: isActive
                  ? 'var(--ds-button-primary-gradient)'
                  : 'transparent',
                boxShadow: isActive
                  ? '0 0 0 1px var(--ds-button-primary-border)'
                  : 'none',
                '&:hover': {
                  borderColor: isActive
                    ? 'var(--ds-button-primary-border-hover)'
                    : 'var(--ds-button-secondary-border-hover)',
                  color: isActive
                    ? 'var(--ds-button-primary-text)'
                    : 'var(--ds-button-secondary-text)',
                  background: isActive
                    ? 'var(--ds-button-primary-gradient-hover)'
                    : 'var(--ds-button-secondary-gradient-hover)'
                }
              }}
            >
              {page.title}
            </Button>
          );
        })}
      </Box>
    </Box>
  );
};
